import { render, staticRenderFns } from "./SlideSharedLinkMenu.vue?vue&type=template&id=2e872ce3&scoped=true"
import script from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
export * from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlideSharedLinkMenu.vue?vue&type=style&index=0&id=2e872ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e872ce3",
  null
  
)

export default component.exports